var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7778 4.89797V1.58051C14.7778 1.05919 14.3028 0.63266 13.7222 0.63266H1.05556C0.475 0.63266 0 1.05919 0 1.58051V11.059C0 11.5803 0.475 12.0068 1.05556 12.0068H13.7222C14.3028 12.0068 14.7778 11.5803 14.7778 11.059V7.7415L19 11.5329V1.10658L14.7778 4.89797Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCamera);
export default __webpack_public_path__ + "static/media/ActiveCamera.498c3e59692ea4380ec1128228a03af2.svg";
export { ForwardRef as ReactComponent };